import { Button } from 'components/ui';
import { withStepperContext } from 'components/ui/stepper';
import compose from 'lodash.flowright';
import PropType from 'prop-types';
import React from 'react';
import { toast } from 'sonner';

export class NextStep extends React.PureComponent {
  static propTypes = {
    nextStep: PropType.func.isRequired,
    isValid: PropType.bool.isRequired,
    stepState: PropType.oneOfType([PropType.func, PropType.object]).isRequired,
    nextStepName: PropType.string.isRequired
  };

  goNext = async () => {
    const { nextStep, stepState, nextStepName } = this.props;

    try {
      let result = stepState;
      if (stepState instanceof Function) result = await stepState();
      nextStep(nextStepName, result);
    } catch (error) {
      toast.error(error.message);
    }
  };

  render() {
    const {
      nextStep,
      prevStep,
      isValid,
      stepState,
      nextStepName,
      prevSteps,
      activeStep,
      ...props
    } = this.props;
    return (
      <Button
        data-testid="next-step"
        disabled={!isValid}
        onClick={this.goNext}
        {...props}
      >
        Next
      </Button>
    );
  }
}

export default compose(withStepperContext)(NextStep);
